module.exports = __webpack_public_path__ + "media/images/iconEdit__accent--dark-e0be41f77c73bbe421f7ab4bd692de90.png";